import React from 'react';
import { Link } from 'react-router-dom';
import TrueCompLogo from '../../assets/truecomp_logo.png';


export function AppLogo(props: { style: React.CSSProperties }) {
  return <>
    <div style={props.style}>
      <img style={{ height: '40px' }} src={TrueCompLogo} alt="TrueComp, Inc. Logo"/>
    </div>
    <div style={props.style}>
      <div style={{ fontWeight: 1.2, fontSize: '1.5rem', marginLeft: '10px' }}>
        <Link to="/app">
          <div style={{ color: 'var(--color-black)' }}>
            Forecasting
          </div>
        </Link>
      </div>
    </div>
  </>;
}